var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"src":_vm.videoUrl,"controls":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }